import styled from 'styled-components';
import { colors } from 'style/theme';
import { sizes } from 'style';
import { SectionContainer } from '../../styled';

export const CoverageContainer = styled(SectionContainer)`
  padding-top: 40px;
  background-color: ${colors.portGore};

  @media ${sizes.desktop} {
    padding-top: 80px;
    background-color: transparent;
  }
`;

export const ImageBg = styled.div`
  background-color: ${colors.portGore};

  @media ${sizes.desktop} {
    background-color: transparent;
    margin-top: -350px;
  }

  @media ${sizes.monitor} {
    margin-top: 0;
  }
`;
